import SchoolEdition from './SchoolEdition';

export default SchoolEdition;
